import { useState } from "react";

import clsx from "clsx";
import { Link } from "react-router-dom";

import { useUser } from "@components/user-context";
import { useFeatureFlags } from "@hooks/http";
import { PrimaryButton, SecondaryButton } from "@shared/buttons";

import { UploadDocumentModal } from "./modals";

export interface DocumentsHeaderProps {
  readonly isDisabled?: boolean;
  readonly isRefreshing?: boolean;
  readonly onRefresh: () => void;
  readonly onUploadSuccess: () => void;
  className?: string;
}

export const DocumentsHeader = ({
  isDisabled,
  isRefreshing,
  onUploadSuccess,
  onRefresh,
  ...props
}: DocumentsHeaderProps) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const { hasFeatureFlag } = useFeatureFlags();
  const { user } = useUser();

  return (
    <div
      {...props}
      className={clsx("flex align-items-center gap-3", props.className)}
    >
      <h1 className="heading mx-0 mb-0 mt-0">Documents</h1>
      <div className="flex gap-3 flex-grow">
        {(user.isAdmin || hasFeatureFlag("allowDocumentsUpload")) && (
          <>
            <PrimaryButton
              className="flex items-center gap-2"
              onClick={() => setUploadModalOpen((v) => !v)}
            >
              <i className="fa-regular fa-upload" />
              UPLOAD
            </PrimaryButton>
            <UploadDocumentModal
              isOpen={uploadModalOpen}
              onClose={() => setUploadModalOpen(false)}
              onUploadSuccess={() => {
                setUploadModalOpen(false);
                onUploadSuccess();
              }}
            />
          </>
        )}
        <PrimaryButton
          className="flex items-center gap-2"
          loading={isRefreshing}
          disabled={isDisabled}
          onClick={() => onRefresh()}
        >
          <i className="fa-regular fa-rotate-right" />
          REFRESH
        </PrimaryButton>
      </div>
      <div>
        {hasFeatureFlag("enableDataExportManagementPage") && (
          <Link
            className="no-underline"
            to={user.pathFromRoot("settings/manage-exports")}
            target="_blank"
            rel="noreferrer"
          >
            <SecondaryButton className="flex items-center gap-2">
              <i className="fa-regular fa-calendar" />
              MANAGE SCHEDULED EXPORTS
            </SecondaryButton>
          </Link>
        )}
      </div>
    </div>
  );
};
